import { render, staticRenderFns } from "./NurseBookingAfterPayment.vue?vue&type=template&id=2adf98ba&scoped=true&"
import script from "./NurseBookingAfterPayment.vue?vue&type=script&lang=js&"
export * from "./NurseBookingAfterPayment.vue?vue&type=script&lang=js&"
import style0 from "./NurseBookingAfterPayment.vue?vue&type=style&index=0&id=2adf98ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf98ba",
  null
  
)

export default component.exports